module.exports = "/wwwroot/img/process_block.png?ver=8c6434fd";